import {DceJsx, DceJsxRenderer} from "dce-jsx";
import {Editor} from "@tiptap/core";
import {Transaction, NodeSelection} from "prosemirror-state";
import ICONS from "../../assets/ICONS";
import {ToolbarItem} from "../ToolbarItem";

interface CellOption {
    x: number,
    y: number,
    node: HTMLElement
}

export class TableItem extends ToolbarItem {

    private editor: Editor;

    private optionsCells: CellOption[] = [];
    public mount(editor: Editor): void {
        this.editor = editor;
    }


    bindByRef(ref: string, elem: HTMLElement) {
        if(ref == 'cell-square'){
            this.optionsCells.push({
                x: parseInt(elem.dataset['col']),
                y: parseInt(elem.dataset['row']),
                node: elem
            });
        }
    }

    public consumeTransaction(editor: Editor, transaction: Transaction): void{

    }

    public click(){
        //open menu
        console.log("CLICK OPEN BUTTON");

        if(!this.root.classList.contains('disabled')) {
            if(!this.root.classList.contains('opened')) {
                this.root.classList.add('opened');
            }else{
                this.root.classList.remove('opened');
            }
        }

        console.log(this.optionsCells);

    }

    public optionsMouseMove(e: any){
        let c = Math.round(e.offsetX / 20);
        let r = Math.round(e.offsetY / 20);

        console.log("MOVE", c, r);

        this.optionsCells.forEach(z => {
            if (z.x < c && z.y < r) {
                z.node.classList.add('active');
            } else {
                z.node.classList.remove('active');
            }
        });
    }

    public optionsClick(e: any){
        let c = Math.floor(e.offsetX / 20);
        let r = Math.floor(e.offsetY / 20);

        this.editor.chain().focus()
            .insertTable({ rows: (r+1), cols: (c+1), withHeaderRow: true })
            .run()

    }

    render(): JSX.Element {

        let c: number[][] = [];
        for (var i = 0; i < 10; i++) {

            let r: number[] = [];
            for(var j=0; j<10; j++){
                r.push(j)
            }
            c.push(r);
        }

        return (
            <button type="button" onClick={() => this.click()} className={"btn dropdown"}>
                <i ref={"current-icon"} dangerouslySetInnerHTML={{__html: ICONS.table}}></i>

                <div className={"options table-insert"} onMouseMove={e => this.optionsMouseMove(e)} onClick={e => this.optionsClick(e)}>
                    {
                        c.map((row, i) => {
                            return (
                                row.map((r, j) => {
                                    return (
                                        <span ref="cell-square" className={"table-cell-square"} data-row={i} data-col={j} >&nbsp;</span>
                                    )
                                })
                            )
                        })
                    }
                </div>
            </button>
        )
    }

}

